import { Button, InfoPage, isLoggedIn } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import useTranslation from "../../hooks/useTranslation";

function VerifyEmailSuccess() {
  const navigation = useNavigation();
  const { t, m } = useTranslation();
  const buttonText = isLoggedIn() ? t(m.Account.BackToAccount) : t(m.Account.BackToLogin);
  function navigateOnClick() {
    isLoggedIn() ? navigation.goToProfile() : navigation.goToSignIn();
  }

  return (
    <InfoPage
      variant="success"
      title={t(m.Account.EmailVerified)}
      description={t(m.Account.EmailVerifiedDescription)}
      primaryCTA={<Button onClick={navigateOnClick}>{buttonText}</Button>}
    />
  );
}

export default VerifyEmailSuccess;
